// @view/authentication/PasswordResetNotice.view.tsx

import React from "react";
import type { PasswordResetRequestViewProps } from "@ps-bridge/contracts/passwordResetRequest";
import * as styles from "@styles/PasswordReset.css";

type PasswordResetNoticeContractProps = Pick<PasswordResetRequestViewProps, never>;

const PasswordResetNoticeView: React.FC<PasswordResetNoticeContractProps> = () => {
  return (
    <p className={styles.notice}>
      If an account exists for that email, a reset link is on the way.
    </p>
  );
};

export default PasswordResetNoticeView;
